export default __webpack_public_path__ + "static/media/map_transparent_blue.76243fad.png";